export let statusTabs = [
  { label: '待审核', value: 'WAITING_FINANCE_AUDIT' },
  { label: '审核通过', value: 'FINANCE_PASSED' }
]
